import type { ClientAccount, Quote, VideoTestimonial } from './schema'

export const proofPage = {
  eyebrow: 'Proof',
  titleThin: 'Systems that',
  titleBold: 'keep running.',
  bands: { videos: 'On camera', quotes: 'In the community', clients: 'Client accounts' },
  lede: 'The systems I build and run for clients today — and what each one keeps moving.',
}

/** Client names stay anonymised: the label is shown, the role and the work say what you do for them. */
export const clientAccounts: ClientAccount[] = [
  {
    label: 'DC Marketing Growth LLC',
    role: 'AI Automation Specialist',
    work: 'I design, build and run the automation systems behind client campaigns: lead management, CRM updates, content generation, reporting dashboards and appointment scheduling.',
    tags: ['n8n', 'Make.com', 'Zapier', 'AI agents'],
  },
  {
    label: 'AA Health Insurance',
    role: 'Support systems builder',
    work: 'I built the support ticketing system inside GoHighLevel that captures, categorizes and tracks every customer request from submission to resolution — with automatic follow-ups and a reopen window.',
    tags: ['GoHighLevel', 'Pipelines', 'Email & SMS'],
  },
]

export const videoTestimonials: VideoTestimonial[] = []

export const communityQuotes: Quote[] = []
